export default __webpack_public_path__ + "static/media/gable.21d2b185.png";